import { Delegate } from './delegate.js';

if (!customElements.get('product-collapsible-tabs')) {
  class ProductCollapsibleTabs extends HTMLElement {
    #delegate = null;
    #tabs = [];
    #panels = [];

    connectedCallback() {
      this.#tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.#panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      const initialIndex = Number(this.dataset.initialTab) || 0;
      this.#activate(initialIndex);

      this.#delegate = new Delegate(this);
      this.#delegate.on('click', '[data-action="select-tab"]', this.#onTabClick);
    }

    disconnectedCallback() {
      this.#delegate?.destroy();
      this.#delegate = null;
      this.#tabs = [];
      this.#panels = [];
    }

    /**
     * Handles delegated click on a tab button.
     * @param {MouseEvent} event
     * @param {HTMLElement} tab
     */
    #onTabClick = (event, tab) => {
      event.preventDefault();

      const index = Number(tab?.dataset?.index);
      if (!Number.isNaN(index)) {
        this.#activate(index);
      }
    };

    /**
     * Activates a tab/panel by index.
     * @param {number} index
     */
    #activate(index) {
      if (
        index < 0 ||
        index >= this.#tabs.length ||
        index >= this.#panels.length
      )
        return;

      this.#tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.classList.toggle('btn--active', isActive);
      });

      this.#panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
    }
  }

  customElements.define('product-collapsible-tabs', ProductCollapsibleTabs);
}
